<template>
  <div class="d-flex flex-column page-container">
    <div class="flex-grow-1">
      <alerts/>
      <banner/>
      <div class="alerts" v-if="isAnyFieldMissing || isAnyAgreementMissing">
        <div class="alert alert-info" v-if="isAnyAgreementMissing && $route.name === 'AgreementsPage'">
          Aby w pełni korzystać ze swojego konta, wyraź zgody obowiązkowe.
        </div>
        <div class="alert alert-info" v-if="isAnyFieldMissing && $route.name === 'ProfilePage'">
          Aby w pełni korzystać ze swojego konta, uzupełnij brakujące dane obowiązkowe.
        </div>
      </div>
      <slot></slot>
    </div>
    <page-modal></page-modal>
    <footer-bar></footer-bar>
  </div>
</template>

<script>
  import FooterBar from "@/components/footer/Bar"
  import PageModal from "../modal/PageModal";
  import {mapState} from "vuex";
  import Alerts from "../alerts/Alerts";
  import Banner from "../banners/Banner";

  export default {
    name: "Page",
    components: {Banner, Alerts, PageModal, FooterBar},
    computed: {
      ...mapState({
        isAnyFieldMissing: state => state.auth.user.missing_fields.length > 0,
        isAnyAgreementMissing: state => state.auth.user.missing_agreements.length > 0,
      }),
    }
  }
</script>

<style>
  .page-container {
    min-height: 100%;
    width: calc(100% - 255px);
  }

  @media (max-width: 1024px) {
    .page-container {
      width: 100%;
    }
  }

  .alerts:not(:empty) {
    padding: 30px 30px 0;
  }

  @media (max-width: 1024px) {
    .alerts:not(:empty) {
      padding: 20px 20px 0;
    }
  }


  .alerts:not(:empty) + .alerts:nth-child(2) {
    padding-top: 0;
  }
</style>
